import React from 'react';
import { Stack, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { formatCompactAedAmount } from '../utils/formatters';

/**
 * Renders an AED amount; when the integer part exceeds 10 digits, truncates.
 * Shows an info icon with the full value unless `compareTooltip` is set (results
 * table already has an ERP vs Marmin hover — avoid a second tooltip).
 */
const CompactAmount = ({ value, prefix = '', abs = false, compareTooltip, iconTooltip, sx, iconSx }) => {
  const raw = value === null || value === undefined || value === '' ? value : abs ? Math.abs(Number(value)) : value;
  const { display, full, truncated } = formatCompactAedAmount(raw);
  const text = display === '—' ? '—' : `${prefix}${display}`;
  const showOverflowIcon = truncated && !compareTooltip;

  const body = (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      component="span"
      sx={{ display: 'inline-flex', minWidth: 0, maxWidth: '100%', ...sx }}
    >
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{text}</span>
      {showOverflowIcon && (
        <Tooltip title={iconTooltip ?? full} arrow>
          <InfoOutlinedIcon sx={{ fontSize: 14, color: 'text.secondary', flexShrink: 0, cursor: 'help', ...iconSx }} />
        </Tooltip>
      )}
    </Stack>
  );

  if (compareTooltip) {
    return (
      <Tooltip title={compareTooltip} arrow>
        <span style={{ display: 'inline-flex', minWidth: 0, maxWidth: '100%' }}>{body}</span>
      </Tooltip>
    );
  }

  return body;
};

export default CompactAmount;
